module.exports = __webpack_public_path__ + "static/media/The-West-Subscription_devicecomp_min.d2f14bfb.png";